import { Chip, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useMemo } from "react";
import { CommentedEvent } from "src/store/api/generatedApi";

export type Disposition = "NOT_REVIEWED" | "REVIEWED_NO_CHANGE" | "EDITED";

export const dispositionFor = (event: CommentedEvent): Disposition => {
  if (event.last_edited_at !== null) {
    return "EDITED";
  }
  if (event.reviewed_at !== null) {
    return "REVIEWED_NO_CHANGE";
  }
  return "NOT_REVIEWED";
};

export const DispositionChip = ({
  disposition,
  label,
  tooltip,
}: {
  disposition: Disposition;
  label: string;
  tooltip?: string;
}) => {
  const theme = useTheme();

  const colors = useMemo(() => {
    switch (disposition) {
      case "EDITED":
        return {
          backgroundColor: alpha(theme.palette.info.light, 0.13),
          border: `1px solid ${theme.palette.info.main}`,
          color: theme.palette.text.primary,
        };
      case "REVIEWED_NO_CHANGE":
        return {
          backgroundColor: alpha(theme.palette.success.light, 0.13),
          border: `1px solid ${theme.palette.success.light}`,
          color: theme.palette.text.primary,
        };
      case "NOT_REVIEWED":
        return {
          backgroundColor: theme.palette.grey[100],
          border: `1px solid ${theme.palette.grey[300]}`,
          color: theme.palette.text.secondary,
        };
    }
  }, [disposition, theme]);

  const chip = (
    <Chip size="small" label={label} sx={{ fontWeight: 500, ...colors }} />
  );

  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};
